import React, { useEffect, useRef, useState } from "react";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";
import DatePicker, { registerLocale } from "react-datepicker";
import BootstrapTable from "react-bootstrap-table-next";
import { dateFormat, priceFormat } from "utils/format";
import { Trash, Trash2 } from "react-feather";
import classNames from "classnames";
import { toast } from "react-toastify";

import { Cut } from "components/Cut";

import "react-datepicker/dist/react-datepicker.css";

import { MySpinner } from "components/MySpinner";
import { TableButton } from "components/TableButton";
import {
  removeOrderToProviderProducts,
  // supplyFileImportUpload,
  updateOrderToProviderProduct,
} from "services/apiSupply";

import "./ordersToProviderProductTable.scss";
import { BarChart } from "components/BarChart";
import { SkladPopup } from "features/Orders/SkladPopup";
import { useNomenclatureModal } from "contexts/NomenclatureModalContext";
import { Button, Card, CardBody } from "reactstrap";
import { CutLink } from "components/CutLink";

export const OrdersToProviderProductTable = ({
  id,
  products,
  setProducts,
  carriedOut,
  provider,
  getAndSetOrderToProvider
}) => {
  const [loading, setLoading] = useState(false);
  const [selected, setSelected] = useState([]);
  const { openNomenclatureModal } = useNomenclatureModal();

  const removeProductsHandler = (id = null) => {
    if (!window.confirm("Вы действительно хотите удалить выбранные товары?")) {
      return;
    }

    setLoading(true);

    removeOrderToProviderProducts({ ids: id ? [id] : selected })
      .then((res) => {
        setProducts(res.products);
      })
      .catch((e) => {
        toast.error(e.response?.data?.message);
      })
      .finally(() => {
        setLoading(false);
        setSelected([]);
      });
  };

  const productHandler = (oldData, newData, row) => {
    if (String(oldData) === String(newData)) return;
    setLoading(true);

    updateOrderToProviderProduct({
      id: row.id,
      price: row.price,
      count: row.count,
      dateArrival: dateFormat(row.dateArrival),
    })
      .then((res) => {
        setProducts(res.products);
      })
      .finally(() => setLoading(false));
  };

  const selectRow = {
    mode: "checkbox",
    bgColor: "#bfbfbf",
    onSelect: (row, isSelect, rowIndex, e) => {
      setSelected((prev) => {
        if (!isSelect) {
          prev.splice(
            prev.findIndex((val) => val === row.id),
            1
          );
          return [...prev];
        }
        return [...prev, row.id];
      });
    },
    onSelectAll: (isSelect, rows, e) => {
      if (!isSelect) {
        setSelected([]);
      } else {
        setSelected(products.map((val) => val.id));
      }
    },
  };

  const tableProductsColumns = [
    {
      dataField: "index",
      text: "№",
      headerStyle: (colum, colIndex) => {
        return { width: "2%" };
      },
      editable: false,
      footer: () => null,
    },
    {
      dataField: "brand",
      text: "Бренд",
      formatter: (cell, row) => <CutLink
        onClick={() => openNomenclatureModal(row.nomenclature?.id)}
        nomenclature={row.nomenclature}
      >
        {row.nomenclature?.brand}
      </CutLink>,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
      editable: false,
      footer: () => null,
    },
    {
      dataField: "article",
      text: "Артикул",
      formatter: (cell, row) => <CutLink
        onClick={() => openNomenclatureModal(row.nomenclature?.id)}
        nomenclature={row.nomenclature}
      >
        {row.nomenclature?.article}
      </CutLink>,
      headerStyle: (colum, colIndex) => {
        return { width: "10%" };
      },
      editable: false,
      footer: () => null,
      clickToSelect: false,
    },
    {
      dataField: "name",
      text: "Наименование",
      formatter: (cell, row) => <CutLink
        onClick={() => openNomenclatureModal(row.nomenclature?.id)}
        nomenclature={row.nomenclature}
      >
        {row.nomenclature?.name}
      </CutLink>,
      headerStyle: (colum, colIndex) => {
        return { width: "15%" };
      },
      editable: false,
      footer: () => null,
    },
    {
      dataField: "price",
      text: "Цена",
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
      formatter: (cell) => priceFormat(cell),
      headerClasses: () => "right",
      classes: () => classNames("right bold"),
      footer: () => null,
    },
    {
      dataField: "count",
      text: "Кол-во",
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
      headerClasses: () => "right",
      footerClasses: () => "right",
      classes: () => classNames("right", { editable: !carriedOut }),
      footer: (columnData) => {
        const total = columnData.reduce((acc, item) => acc + parseInt(item), 0);
        return total;
      },
    },
    {
      dataField: "summ",
      text: "Сумма",
      headerStyle: (colum, colIndex) => {
        return { width: "9%" };
      },
      formatter: (cell) => priceFormat(cell),
      headerClasses: () => "right",
      footerClasses: () => "right bold",
      classes: () => "right bold",
      editable: false,
      footer: (columnData) => {
        const total = columnData.reduce(
          (acc, item) => acc + parseFloat(item),
          0
        );
        return total && priceFormat(total);
      },
    },
    {
      dataField: "priceDifference",
      text: "Разн с тек.себ.",
      headerStyle: (colum, colIndex) => {
        return { width: "7%" };
      },
      formatter: (cell, row) => <>{cell} %</>,
      headerClasses: () => "right",
      classes: () => "right bold",
      editable: false
    },
    {
      dataField: "abc",
      text: "ABC",
      headerStyle: (colum, colIndex) => {
        return { width: "4%" };
      },
      footer: () => null,
      editable: false,
    },
    {
      dataField: "status",
      text: "Статус",
      headerStyle: (colum, colIndex) => {
        return { width: "4%" };
      },
      footer: () => null,
      editable: false,
    },
    {
      dataField: "minStock",
      text: "Мин.Ост",
      headerStyle: (colum, colIndex) => {
        return { width: "4%" };
      },
      footer: () => null,
      editable: false,
    },
    {
      dataField: "marketplacePrice",
      text: "Площадки",
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
      formatter: (cell, row) => priceFormat(row.marketplacePrice),
      headerClasses: () => "right",
      footerClasses: () => "right",
      classes: () => "right",
      editable: false,
    },
    {
      dataField: "sold",
      text: "Продано",
      headerStyle: (colum, colIndex) => {
        return { width: "6%" };
      },
      headerClasses: () => "right",
      footerClasses: () => "right",
      classes: () => "right",
      editable: false,
    },
    {
      dataField: "inStockAll",
      text: "Ост.",
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
      formatter: (cell, row) => (
        <div className="warehouse-container">
          {(cell || row.inStockAll) && (
            <SkladPopup row={row}>
              <BarChart
                color={cell > 0 ? "green" : "red"}
                count={row.inStockAll}
              />
            </SkladPopup>
          )}
        </div>
      ),
      headerClasses: () => "right",
      classes: (cell) => "right",
      footer: () => null,
      editable: false,
    },
    {
      dataField: "ordered",
      text: "Зак всего",
      headerStyle: (colum, colIndex) => {
        return { width: "4%" };
      },
      headerClasses: () => "right",
      classes: (cell) => "right",
      footer: () => null,
      editable: false,
    },
    {
      dataField: "supply",
      text: "Пост-е",
      headerStyle: (colum, colIndex) => {
        return { width: "4%" };
      },
      headerClasses: () => "right",
      classes: (cell) => classNames({ "success": cell }),
      footer: () => null,
      editable: false,
    },
    {
      dataField: "",
      text: "",
      formatter: (cell, row) => (
        <TableButton
          Icon={Trash2}
          onClick={() => removeProductsHandler(row.id)}
        />
      ),
      headerStyle: (colum, colIndex) => {
        return { width: "5%" };
      },
      footer: () => null,
      editable: false,
    },
  ];

  return (
    <>
      {loading && <MySpinner overlay />}

      {selected.length > 0 &&
        <Card >
          <CardBody className="pt-0 pb-0">
            <Button onClick={() => removeProductsHandler()} color="danger">
              <Trash size="15" /> Удалить
            </Button>
          </CardBody>
        </Card>
      }

      <BootstrapTable
        wrapperClasses="orders-to-provider-product"
        keyField="id"
        data={products}
        hover={true}
        columns={tableProductsColumns}
        bootstrap4
        bordered={false}
        cellEdit={cellEditFactory({
          mode: "click",
          blurToSave: true,
          afterSaveCell: (oldData, newData, row) =>
            productHandler(oldData, newData, row),
        })}
        selectRow={selectRow}
      />

    </>
  );
};
